import React, { useEffect, useState, useRef } from "react";
import "./css/CustomerFilesData.css";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import moment from "moment";
import { api } from "../../../../../../../../../utility/AxiosInceptor";
import CommonLoaderBlue from "../../../../../../../../components/Loader/LoaderBlue";
import NotFoundData from "../../../Payments/Common/Notfound/Notfound";
import { CancelPopup, CheckMark } from "./assets/Assets";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
export const CustomerFilesData = ({
  selectedModule,
  selectedRange,
  refreshCustomerFiles,
  cpData,
}) => {
  const [allFilesData, setAllFilesData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [overlayContent, setOverlayContent] = useState("");
  const statusOverlayRef = useRef(null);
  const [isFileDataLoading, setIsFileDataLoading] = useState(true);
  const [isAPiCalled, setIsApiCalled] = useState(false);
  const getCustomerFiles = async () => {
    setIsApiCalled(false);
    api
      .get(`/api/web/uploadfiles/get-uploaded-files?enrollmentId=${cpData._id}`)
      .then((invoiceResponse) => {
        setAllFilesData(invoiceResponse?.data);
        setIsApiCalled(true);
        setIsFileDataLoading(false);
      })
      .catch((err) => {
        setAllFilesData([]);
        setIsFileDataLoading(false);
      });
  };
  useEffect(() => {
    if (cpData && Object.keys(cpData).length > 0) {
      setSelectedRows([]);
      getCustomerFiles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cpData, refreshCustomerFiles]);

  return (
    <div className="main-customerfiles-data">
      <h1 className="top-header-files-data">Uploaded Files</h1>
      {!isFileDataLoading && isAPiCalled && allFilesData?.length === 0 ? (
        <NotFoundData currentNoFoundData={"files"} />
      ) : (
        <DataTable
          onRowClick={(rowData) => {
            if (
              selectedRows.some(
                (item) => rowData.data.filepath === item.filepath
              )
            ) {
              setSelectedRows(
                selectedRows.filter(
                  (item) => item.filepath !== rowData.data.filepath
                )
              );
            } else {
              setSelectedRows([...selectedRows, rowData.data]);
            }
          }}
          value={allFilesData}
        >
          <Column
            header={() => {
              return (
                <div
                  tooltip="hello"
                  className="main-header-filetype flex flex-wrap flex-row  align-items-center"
                >
                  <div>
                    {" "}
                    <div
                      onClick={() => {
                        if (selectedRows.length < allFilesData.length) {
                          setSelectedRows(allFilesData);
                        } else {
                          setSelectedRows([]);
                        }
                      }}
                      className={`${allFilesData.length > 0 && selectedRows.length === allFilesData.length ? "checked" : ""}`}
                    >
                      {allFilesData.length > 0 &&
                        selectedRows.length === allFilesData.length && (
                          <CheckMark />
                        )}
                    </div>
                  </div>
                  <p>File Type</p>
                </div>
              );
            }}
            body={(rowData, { rowIndex }) => {
              const ischecked = selectedRows.some(
                (item) => rowData.filepath === item.filepath
              );
              let filetypevalue = rowData?.fileType;
              let fileType = rowData?.fileType;
              if (fileType.length > 10) {
                filetypevalue = fileType.substring(0, 10) + "...";
              } else {
                filetypevalue = fileType;
              }

              return (
                <div className="main-row-filetype flex flex-wrap flex-row  align-items-center">
                  <div>
                    <div className={`${ischecked ? "checked" : ""}`}>
                      {ischecked && <CheckMark />}
                    </div>
                  </div>
                  <p
                    className="cursor-pointer"
                    onMouseEnter={(e) => {
                      if (fileType.length > 10) {
                        setOverlayContent(rowData?.fileType);
                        statusOverlayRef.current.show(e);
                      }
                    }}
                    onMouseLeave={() => statusOverlayRef.current.hide()}
                  >
                    {filetypevalue || "NIL"}
                  </p>
                  <OverlayPanel ref={statusOverlayRef}>
                    <div style={{ maxWidth: "20rem", padding: "0.5rem 1rem" }}>
                      <p
                        style={{
                          fontWeight: 400,
                          fontSize: "1.4rem",
                          overflow: "hidden",
                          border: "none",
                          margin: "0rem",
                          lineHeight: "1.8rem",
                          color: "#72728f",
                        }}
                      >
                        {" "}
                        {overlayContent}
                      </p>
                    </div>
                  </OverlayPanel>
                </div>
              );
            }}
          />
          <Column
            header="Date"
            body={(rowData) => {
              return (
                <span>
                  {rowData?.uploadDate
                    ? moment(rowData?.uploadDate)
                        .tz("America/New_York") // Convert to New York time (Eastern Time Zone)
                        .format("MM-DD-YYYY")
                    : "NIL"}
                </span>
              );
            }}
          />
          <Column
            field=""
            header="Uploaded By"
            body={(rowData) => {
              return <span> {rowData?.uploadedBy?.name || "NIL"}</span>;
            }}
          />

          <Column
            field="file"
            body={(rowData) => {
              let filePathvalue;
              let filePath = rowData?.filepath;
              if (filePath) {
                let actualfilepath = rowData.filepath.substring(
                  rowData.filepath.lastIndexOf("/") + 1
                );
                if (actualfilepath.length > 9) {
                  filePathvalue = actualfilepath.substring(0, 9) + "...";
                } else {
                  filePathvalue = actualfilepath;
                }
              }
              return (
                <div>
                  <p
                    className="cursor-pointer"
                    onMouseEnter={(e) => {
                      if (filePath.length > 9) {
                        setOverlayContent(
                          rowData.filepath.substring(
                            rowData.filepath.lastIndexOf("/") + 1
                          )
                        );
                        statusOverlayRef.current.show(e);
                      }
                    }}
                    onMouseLeave={() => statusOverlayRef.current.hide()}
                  >
                    {filePathvalue ? filePathvalue : "NIL"}
                  </p>
                  <OverlayPanel ref={statusOverlayRef}>
                    <div style={{ maxWidth: "20rem", padding: "0.5rem 1rem" }}>
                      <p
                        style={{
                          fontWeight: 400,
                          fontSize: "1.4rem",
                          overflow: "hidden",
                          border: "none",
                          margin: "0rem",
                          lineHeight: "1.8rem",
                          color: "#72728f",
                        }}
                      >
                        {" "}
                        {overlayContent}
                      </p>
                    </div>
                  </OverlayPanel>
                </div>
              );
            }}
            header="File"
          />
        </DataTable>
      )}
      {isFileDataLoading ? (
        <div className="loader-wrapper">
          <CommonLoaderBlue color="royalblue" sizehere={21} />
        </div>
      ) : (
        ""
      )}
      {selectedRows?.length > 0 && (
        <div className="flex flex-column justify-content-start align-items-center selecteddatapopup">
          <div className="flex w-full justify-content-end">
            <span
              onClick={() => {
                if (!isDownloading) {
                  setSelectedRows([]);
                }
              }}
              style={{ cursor: "pointer" }}
            >
              <CancelPopup />
            </span>
          </div>
          <div className="flex justify-content-between w-full align-items-center selectedrowdata   ">
            <div className="show-details-row flex flex-wrap fex-row justify-content-start align-items-center">
              <p>Selected:</p>
              <p>{selectedRows?.length}</p>
            </div>

            <Button
              disabled={isDownloading}
              onClick={() => {
                setIsDownloading(true);

                selectedRows.forEach((item) => {
                  const fileUrl = (
                    process.env.REACT_APP_BASE_URL +
                    "/" +
                    item.filepath
                  ).replace("/uploads", "");

                  fetch(fileUrl)
                    .then((response) => {
                      if (!response.ok)
                        throw new Error("Network response was not ok");
                      return response.blob();
                    })
                    .then((blob) => {
                      const url = window.URL.createObjectURL(blob);
                      const link = document.createElement("a");
                      link.href = url;

                      const fileName = `accountId_${cpData.accountId}_${item.fileType}_${item.fileName}`;
                      link.download = fileName;
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      window.URL.revokeObjectURL(url);
                    })
                    .catch((error) => {
                      console.error("Download failed for:", fileUrl, error);
                    });
                });

                setTimeout(() => setIsDownloading(false), 1000);
              }}
              className="adduserbtn"
              label={
                !isDownloading ? (
                  "Download"
                ) : (
                  <div className="w-full justify-content-center flex items-center">
                    <CommonLoaderBlue sizehere={14} color={"white"} />
                  </div>
                )
              }
              style={{ width: "12rem" }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
